import * as angular from 'angular';

const reportSettingsModalDirective = function (Modal) {
  return {
    restrict: 'A',
    scope: {
      report: '<',
      owner: '<',
    },
    link: function ($scope: any, elem, attrs) {
      elem.on('click.reportSettings', (event) => {
        const modal = Modal.open(
          {
            report: $scope.report,
            owner: $scope.owner,
          },
          {
            controllerAs: 'ctrl',
            bindToController: true,
            template: '<report-settings report="report" owner="owner" on-submit="$close()" on-cancel="$dismiss()"/>',
          }
        );
      });

      // cleanup handlers
      $scope.$on('$destroy', () => elem.off('click.reportSettings'));
    },
  };
};

reportSettingsModalDirective.$inject = ['ModalService'];

angular.module('mode.components').directive('reportSettingsModal', reportSettingsModalDirective);
